import React from "react";
import { setToaster } from "../components/Toaster";
import { ToastContainer } from "react-toastify";
import AddPaintingForm from "../components/Paintings/AddPaintingForm";
import { GetTokenFromLocalStorage } from "../components/Account/AuthenticationContext";
import { Redirect } from "../components/Utilities";

interface Props {
  Title: string;
}

interface State {
  redirect: boolean;
}

class AddPainting extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      redirect: false,
    };
  }
  onToaster = (state: any, message: string): void => {
    setToaster({
      state: state,
      message: message,
    });
  };
  componentDidMount(): void {
    let token = GetTokenFromLocalStorage();
    if (token === null || token === undefined) {
      this.setState({ redirect: true });
    }
  }

  render() {
    return (
      <>
        <div className="wrapper">
          <div className="section latest-offers">
            <div className="container">
              <h3 className="section-title">{this.props.Title}</h3>
              <hr />
              <AddPaintingForm onToaster={this.onToaster} />
            </div>
          </div>
        </div>
        <ToastContainer autoClose={2000} />
        {this.state.redirect && <Redirect path="/" />}
      </>
    );
  }
}

export default AddPainting;
